module.exports = __webpack_public_path__ + "img/ideal-logo.55eb36b4.svg";